export default __webpack_public_path__ + "54ddcde1fbb112a447b6c2d96ac8dd7e.svg";